module.exports = __webpack_public_path__ + "static/media/photo73.0839e63d.jpg";